import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    rigthClick: {
      visible: false,
      top: 0,
      left: 0,
      closeOther: false,
      closeCurrent: false,
      closeWhole: false,
    },
    doctorList: {},
    allOrder: {},
    rentGoods: {},
    commodityGroup: {},
    deviceAutho: {},
    remoteMonitor: {},
    configuration: {},
    skuContent: {},
    financeList: {}
  },
  mutations: {
    rigthClick: (state, payload) => {
      state.rigthClick = payload;
    },
    financeList: (state, payload) => {
      state.financeList = payload;
    },
    doctorList: (state, payload) => {
      state.doctorList = payload;
    },
    skuContent: (state, payload) => {
      state.skuContent = payload;
    },
    configuration: (state, payload) => {
      state.configuration = payload;
    },
    remoteMonitor: (state, payload) => {
      state.remoteMonitor = payload;
    },
    USER_INFO: (state, payload) => {
      state.allOrder = payload;
    },
    USER_DATA: (state, payload) => {
      state.rentGoods = payload;
    },
    HOME_DATA: (state, payload) => {
      state.commodityGroup = payload;
    },
    MY_INFO: (state, payload) => {
      state.deviceAutho = payload;
    },
  },
  getters: {
  },
  actions: {
    rigthClick({
      commit
    }, user) {
      commit('rigthClick', user)
    },

    financeList({
      commit
    }, user) {
      commit('financeList', user)
    },

    doctorList({
      commit
    }, user) {
      commit('doctorList', user)
    },

    skuContent({
      commit
    }, user) {
      commit('skuContent', user)
    },

    allOrder({
      commit
    }, user) {
      commit('USER_INFO', user)
    },

    remoteMonitor({
      commit
    }, user) {
      commit('remoteMonitor', user)
    },

    configuration({
      commit
    }, user) {
      commit('configuration', user)
    },

    rentGoods({
      commit
    }, data) {
      commit('USER_DATA', data)
    },

    commodityGroup({
      commit
    }, home) {
      commit('HOME_DATA', home)
    },

    deviceAutho({
      commit
    }, user) {
      commit('MY_INFO', user)
    },
  }
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js